
import { formData, post } from './http'


//获取微信用户信息
export function wechatGetUserInfo(data) {
  return post('/api/wechat/getUserInfo', data)
}

//获取平台用户信息
export function userGetUserInfo(data) {
  return post('/api/user/getUserInfo', data)
}

//获取微信配置
export function wechatJssdk(data) {
  return post('/api/wechat/jssdk', data)
}

//获取client_access_token
export function oauthToken(data) {
  return formData('/oauth/token', data)
}



// WEBPACK FOOTER //
// ./src/api/main.js